import React from 'react';
import { Landmark, UtensilsCrossed, GraduationCap } from 'lucide-react';

const IndustriesData = [
   {
      id: 1,
      slug: 'fintech',
      name: 'FinTech',
      icon: <Landmark size="54" strokeWidth='1' />,
      tagline: 'Secure, Compliant Software for Financial Services',
      description: "From digital banking platforms to fraud-detection tooling, we build software that meets the reliability, security, and compliance bar financial services demand.",
      relevantServiceIds: [1, 3, 4, 8, 9],
      bgColor: "#F7F6FF"
   },
   {
      id: 2,
      slug: 'food-catering',
      name: 'Food & Catering',
      icon: <UtensilsCrossed size="54" strokeWidth='1' />,
      tagline: 'Digital Ordering & Growth for Food Businesses',
      description: "Online ordering platforms, delivery integrations, and marketing systems that help restaurants and catering businesses reach more customers and run smoother operations.",
      relevantServiceIds: [1, 7, 6, 5],
      bgColor: "#ECEEFF"
   },
   // {
   //    id: 3,
   //    slug: 'agriculture',
   //    name: 'Agriculture',
   //    icon: <Wheat size="54" strokeWidth='1' />,
   //    tagline: 'Data-Driven Software for Modern Agriculture',
   //    description: "From farm management platforms to supply-chain and analytics tooling, we build software that helps agricultural businesses operate more efficiently.",
   //    relevantServiceIds: [1, 3, 4, 9],
   //    bgColor: "#e0f2fe"
   // },
   {
      id: 4,
      slug: 'education',
      name: 'Education',
      icon: <GraduationCap size="54" strokeWidth='1' />,
      tagline: 'Digital Platforms for Learning Organizations',
      description: "Learning management systems, student portals, and content platforms designed around the needs of schools, training providers, and edtech businesses.",
      relevantServiceIds: [1, 7, 5, 9],
      bgColor: "#DEE0FF"
   },
   // {
   //    id: 5,
   //    slug: 'healthcare',
   //    name: 'Healthcare',
   //    icon: <HeartPulse size="54" strokeWidth='1' />,
   //    tagline: 'Reliable Software for Healthcare Providers',
   //    description: "Patient-facing portals, internal tooling, and data systems built with the reliability and data discipline healthcare organizations require.",
   //    relevantServiceIds: [1, 4, 8, 9],
   //    bgColor: "#fdf2f8"
   // },
   // {
   //    id: 6,
   //    slug: 'real-estate',
   //    name: 'Real Estate',
   //    icon: <Building2 size="54" strokeWidth='1' />,
   //    tagline: 'Digital Tools for Real Estate Businesses',
   //    description: "Property listing platforms, CRM integrations, and marketing sites that help real estate businesses showcase properties and convert more leads.",
   //    relevantServiceIds: [1, 7, 6, 5],
   //    bgColor: "#fce7f3"
   // },
   // {
   //    id: 7,
   //    slug: 'retail-ecommerce',
   //    name: 'Retail & E-commerce',
   //    icon: <ShoppingCart size="54" strokeWidth='1' />,
   //    tagline: 'Software That Powers Online & Retail Sales',
   //    description: "E-commerce platforms, inventory and data integrations, and AI-driven personalization that help retail businesses sell more, online and in-store.",
   //    relevantServiceIds: [1, 3, 6, 4],
   //    bgColor: "#e5e7eb"
   // },
];

export default IndustriesData;
